import styled from "styled-components";
import Badge from "../Badge";
import IconButton from "./IconButton";
import { Props as IconButtonProps } from "./IconButton";

interface IconLabelButtonProps extends IconButtonProps {
  label: string;
  badgeCount?: number;
}

const IconLabelButton = (props: IconLabelButtonProps) => {
  return (
    <LabeledIconButton>
      <Badge count={props.badgeCount}>
        <IconButton
          iconColor={props.iconColor}
          backgroundColor={props.backgroundColor}
          icon={props.icon}
          size={props.size}
          onClick={props.onClick}
        />
      </Badge>
      <span onClick={props.onClick}>{props.label}</span>
    </LabeledIconButton>
  );
};

export default IconLabelButton;

const LabeledIconButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  border: none;
  background: none;
  span {
    line-height: 30px;
    font-weight: 700;
    margin-left: 12px;
  }
`;
